/*eslint-disable */
import React from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Container } from "semantic-ui-react";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import LoadTypeCheckbox from "../dynamicComponent/loadTypeCheckbox";
import cogoToast from "cogo-toast";
import { FEATURES } from "../../utils/constant";

const InsertVehicleType = ({ values, touched, errors, t }) => (
  <React.Fragment>
    <Formiker>
      <div className="container-fluid animated slideInDown pad w3-white">
        <div className="m-3 pl-3">
          <div className="ui form">
            <FormUi.Group inline>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.vehicle_type_code.title") || "Vehicle Type Code"} <span className="red">*</span>
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={
                  touched.vehicleTypeCode && errors.vehicleTypeCode
                    ? true
                    : false
                }
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="vehicleTypeCode"
                  placeholder={
                    t("create.vehicle_type_code.placeholder") || "Type Code"
                  }
                />
                {touched.vehicleTypeCode && errors.vehicleTypeCode ? (
                  <div className="error-msg">
                    {t(
                      `create.vehicle_type_code.error_msg.${errors.vehicleTypeCode}`
                    ) || errors.vehicleTypeCode}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {" "}
                  {t("create.vehicle_type_name.title") ||
                    "Vehicle Type Name"}{" "}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={touched.vehicleType && errors.vehicleType ? true : false}
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="vehicleType"
                  placeholder={
                    t("create.vehicle_type_name.placeholder") ||
                    "Vehicle Type Name"
                  }
                />
                {touched.vehicleType && errors.vehicleType ? (
                  <div className="error-msg">
                    {t(
                      `create.vehicle_type_name.error_msg.${errors.vehicleType}`
                    ) || errors.vehicleType}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.vehicle_type_tonnage.title") || "Vehicle Type Code"} <span className="red">*</span>
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={
                  touched.vehicleTypeTonnage && errors.vehicleTypeTonnage
                    ? true
                    : false
                }
              >
                <Fieldmik
                  type="number"
                  className="ui input"
                  name="vehicleTypeTonnage"
                  placeholder={
                    t("create.vehicle_type_tonnage.placeholder") || "Type Code"
                  }
                />
                {touched.vehicleTypeTonnage && errors.vehicleTypeTonnage ? (
                  <div className="error-msg">
                    {t(
                      `create.vehicle_type_tonnage.error_msg.${errors.vehicleTypeTonnage}`
                    ) || errors.vehicleTypeTonnage}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.load_type.title") || "Load Types"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={5}
                className="display-grid-center-imp"
                error={
                  touched.loadTypeIds && errors.loadTypeIds
                    ? true
                    : false
                }
              >
                <Fieldmik
                  type="number"
                  className="ui input"
                  name="loadTypeIds"
                  component={LoadTypeCheckbox}
                  loadTypeIds = {values.loadTypeIds}
                />
                {touched.loadTypeIds && errors.loadTypeIds ? (
                  <div className="error-msg">
                    {errors.loadTypeIds}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>

            <FormUi.Group inline>
              
             { FEATURES.partitionInVehicleType &&
             <>
             <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.partition.title") || "Partition"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={
                  touched.partition && errors.partition
                    ? true
                    : false
                }
              >
                <Fieldmik
                  type="number"
                  className="ui input"
                  name="partition"
                  placeholder={
                    t("create.partition.placeholder") || "Partition"
                  }
                />
                {touched.partition && errors.partition ? (
                  <div className="error-msg">
                    {t(
                      `create.vehicle_type_tonnage.error_msg.${errors.vehicleTypeTonnage}`
                    ) || errors.partition}
                  </div>
                ) : null}
              </FormUi.Field>
              </>
              }
            </FormUi.Group>
          </div>
        </div>
      </div>
      <Container className="p-3" textAlign="center">
        <button
          className="w3-button w3-blue w3-hover-blue w3-round w3-small"
          type="submit"
        >
          {t("create.action_button.submit") || "Submit"}
        </button>
      </Container>
    </Formiker>
  </React.Fragment>
);

const FormikVehicleType = withFormik({
  validationSchema: yup.object({
    vehicleType: yup.string().required("required"),
    vehicleTypeCode: yup.string().required("required"),
    vehicleTypeTonnage: yup.number().optional(),
    partition : yup.number().optional(),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    vehicleType: props.editData.vehicleType || "",
    vehicleTypeCode: props.editData.vehicleTypeCode || "",
    vehicleTypeTonnage: props.editData.vehicleTypeTonnage || "",
    loadTypeIds : props.editData.loadTypeIds || [],
    partition : props.editData?.partitionValue || 0
  }),
  async handleSubmit(values, { props }) {
    values.partition = values.partition?.toString()
    if (props.editData.vehicleTypeId) {
      await UpdateAxios({
        url: "vehicleTypeMaster",
        payload: { ...values },
        uniqueId: props.editData.vehicleTypeId,
      })
        .then((res) => {
          cogoToast.success(res?.data?.message || 'Vehicle Type Updated', {position:"top-right", hideAfter:3});
          props.onFormSubmit();
        })
        .catch((err) => {
          cogoToast.success(err?.data?.message || 'Error occurred', {position:"top-right", hideAfter:3});
        });
    } else {
      await CreatAxios({
        url: "vehicleTypeMaster",
        payload: { ...values },
      })
        .then((res) => {
          cogoToast.success(res?.data?.message?.message || 'Vehicle Type Created', {position:"top-right", hideAfter:3});
          props.onFormSubmit();
        })
        .catch((err) => {
          cogoToast.success(err?.data?.message || 'Error occurred', {position:"top-right", hideAfter:3});
        });
    }
  },
})(InsertVehicleType);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate("vehicle_type")(FormikVehicleType));
